import PropTypes from "prop-types";
import { Form, Input, Select } from "antd";

const AddressFields = ({ namePrefix, t, states, countryOptions }) => {
    const fieldName = (key) => [...namePrefix, key];

    return (
        <>
            <Form.Item
                label={t("steps.companyInfo.address")}
                name={fieldName("address")}
                rules={[{ required: true, message: t("validation.required") }]}>
                <Input placeholder={t("steps.companyInfo.addressPlaceholder")} size="large" />
            </Form.Item>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <Form.Item
                    label={t("steps.companyInfo.city")}
                    name={fieldName("city")}
                    rules={[{ required: true, message: t("validation.required") }]}>
                    <Input placeholder={t("steps.companyInfo.cityPlaceholder")} size="large" />
                </Form.Item>

                <Form.Item
                    label={t("steps.companyInfo.zipCode")}
                    name={fieldName("zip")}
                    rules={[{ required: true, message: t("validation.required") }]}>
                    <Input placeholder={t("steps.companyInfo.zipCodePlaceholder")} size="large" />
                </Form.Item>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <Form.Item
                    label={t("steps.companyInfo.state")}
                    name={fieldName("state")}
                    rules={[{ required: true, message: t("validation.required") }]}>
                    <Select
                        showSearch
                        placeholder={t("steps.companyInfo.statePlaceholder")}
                        options={states}
                        size="large"
                        filterOption={(input, option) =>
                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>

                <Form.Item
                    label={t("steps.companyInfo.country")}
                    name={fieldName("country")}
                    rules={[{ required: true, message: t("validation.required") }]}>
                    <Select
                        placeholder={t("steps.companyInfo.countryPlaceholder")}
                        options={countryOptions}
                        size="large"
                        disabled
                    />
                </Form.Item>
            </div>
        </>
    );
};

AddressFields.propTypes = {
    namePrefix: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
    t: PropTypes.func.isRequired,
    states: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })).isRequired,
    countryOptions: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })).isRequired,
};

export default AddressFields;
